import { forwardRef, type SVGProps } from 'react';

export type InfoProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const Info = forwardRef<SVGSVGElement, InfoProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path d="M16 8.84a1.4 1.4 0 011.4 1.4 1.4 1.4 0 11-2.8 0 1.4 1.4 0 011.4-1.4zm0 4.82a1.34 1.34 0 011.4 1.28v7a1.41 1.41 0 01-2.8 0v-7a1.34 1.34 0 011.4-1.28zM16 30a14 14 0 1114-14 14 14 0 01-14 14zm0-25.8A11.8 11.8 0 1027.8 16 11.81 11.81 0 0016 4.2z" />
  </svg>
));
Info.displayName = 'Info';
